import classNames from 'classnames'
import React, { useRef } from 'react'

import Spinner from '../Spinner'

interface Props {
  color: 'primary' | 'secondary' | 'danger'
  className?: string
  icon?: JSX.Element
  loading?: boolean
  disabled?: boolean
  spinnerSize?: number
  onClick?: (event: React.MouseEvent) => void
}

const Button: React.FC<Props & React.HTMLAttributes<HTMLButtonElement>> = ({
  color,
  className,
  icon,
  loading,
  onClick,
  children,
  disabled,
  spinnerSize,
  ...rest
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent) => {
    !disabled && onClick?.(event)
  }

  return (
    <button
      {...rest}
      ref={buttonRef}
      className={classNames(
        'relative flex items-center justify-center overflow-hidden text-white focus:outline-none',
        {
          'cursor-pointer': !loading && !disabled,
          'bg-info-dark hover:bg-info-light focus-visible:bg-info-light':
            !loading && !disabled && color === 'primary',
          'bg-secondary-main hover:bg-secondary-dark focus-visible:bg-secondary-dark':
            !loading && !disabled && color === 'secondary',
          'bg-error-main hover:bg-error-dark focus-visible:bg-error-dark':
            !loading && !disabled && color === 'danger',
          'cursor-default bg-secondary-light': loading || disabled,
        },
        className
      )}
      onClick={handleClick}
    >
      {icon}
      <span className={classNames({ 'ml-2': !!icon })}>{children}</span>
      {loading && (
        <div className="absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 transform items-center justify-center">
          <Spinner className="text-success-dark" size={spinnerSize ?? 30} />
        </div>
      )}
    </button>
  )
}

export default Button
